module.exports = __webpack_public_path__ + "static/img/org_title5.be20085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_title5.png
// module id = QE+j
// module chunks = 4